import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.mainAction && _vm.dropdownActions.length > 0 ? _c(VMenu, {
    attrs: {
      bottom: "",
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c("div", {
          staticClass: "split-btn"
        }, [_c(VBtn, {
          staticClass: "main-btn dfwa-btn --small",
          attrs: {
            rounded: "",
            disabled: _vm.mainAction.disabled,
            loading: _vm.mainAction.loading
          },
          on: {
            click: _vm.mainAction.click
          }
        }, [_c(VIcon, {
          attrs: {
            left: "",
            small: "",
            dark: ""
          }
        }, [_vm._v(_vm._s(_vm.mainAction.icon))]), _vm._v(" " + _vm._s(_vm.mainAction.label) + " ")], 1), _c(VBtn, _vm._g({
          staticClass: "actions-btn dfwa-btn",
          attrs: {
            rounded: "",
            disabled: !_vm.hasActions || _vm.mainAction.loading
          }
        }, on), [_c(VIcon, [_vm._v("mdi-menu-down")])], 1)], 1)];
      }
    }], null, false, 1825701167)
  }, [_c(VList, _vm._l(_vm.dropdownActions, function (item, index) {
    return _c(VListItem, {
      key: index,
      staticClass: "py-2",
      class: item.disabled ? "disabled" : "",
      attrs: {
        disabled: item.disabled,
        dark: ""
      },
      on: {
        click: item.click
      }
    }, [_c(VListItemTitle, [_c(VIcon, {
      staticStyle: {
        color: "black"
      },
      attrs: {
        left: "",
        small: "",
        dark: ""
      }
    }, [_vm._v(_vm._s(item.icon))]), _vm._v(" " + _vm._s(item.label) + " ")], 1)], 1);
  }), 1)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };